import Enum from '@/modules/core/app/helpers/Enum';

export class MessageType extends Enum {
  static USER = 'user';
  static DELETED_USER = 'deleted_user';
  static BOT = 'bot';
  static SYSTEM = 'system';
}
